import { render, staticRenderFns } from "./robbery-case.vue?vue&type=template&id=5504b4ab"
import script from "./robbery-case.vue?vue&type=script&lang=ts"
export * from "./robbery-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports